import { makeAutoObservable } from "mobx";

class ProductStore {
  selectedProductId: number | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Action to set the selected product ID
  setSelectedProductId(productId: number) {
    this.selectedProductId = productId;
  }

  // Getter to retrieve the selected product ID
  get getSelectedProductId() {
    return this.selectedProductId;
  }
}

const productStore = new ProductStore();
export default productStore;
